import { apiORDSpost } from '../shared/api-functions'

const MODULO = 'purchase/compra/'
const MODULOIT = 'purchase/comprait/'

export default {
  methods: {
    async apiCompra(operacao, compra, comprait, comprapar, responseCallback) {
      let data_compra = { ...compra }
      data_compra.comprait = comprait
      data_compra.comprapar = comprapar
      
      let sendData = { compra: data_compra }
      let metodo = 'post'
      
      const data = await apiORDSpost(this.$store, MODULO, sendData, metodo)
      if (!data.items) {
        return
      }

      let validation = null
      if (data.items[0].validation) {
        validation = JSON.parse(data.items[0].validation)
      }

      if (responseCallback) {
        responseCallback(operacao, data.items[0], validation)
      }
    },

    async apiIntegraFinanceiroCompra(codcompra, responseCallback) {
      const url = MODULO + 'financeiro'
      const sendData = { codcompra: codcompra }
      const data = await apiORDSpost(this.$store, url, sendData, 'post')
      
      if (responseCallback) {
        responseCallback(data.items ? data.items[0] : data)
      }
    },

    async apiExcluirFinanceiroCompra(codcompra, responseCallback) {
      const url = MODULO + 'financeiro/excluir'
      const sendData = { codcompra: codcompra }
      const data = await apiORDSpost(this.$store, url, sendData, 'post')
      
      if (responseCallback) {
        responseCallback(data.items ? data.items[0] : data)
      }
    },

    async apiDuplicaCompra(codcompra, responseCallback) {
      const url = MODULO + 'duplica'
      const sendData = { codcompra: codcompra }
      const data = await apiORDSpost(this.$store, url, sendData, 'post')
      
      if (responseCallback) {
        responseCallback(data.items ? data.items[0] : data)
      }
    },

    async apiCancelaCompra(codcompra, responseCallback) {
      const url = MODULO + 'cancelar'
      const sendData = { codcompra: codcompra }
      const data = await apiORDSpost(this.$store, url, sendData, 'post')
      
      if (responseCallback) {
        responseCallback(data.items ? data.items[0] : data)
      }
    },

    async apiEnviaEmailCompra(codcompra, data, responseCallback) {
      const { apiEmailPDF } = require('../shared/api-functions')
      const email = await apiEmailPDF(this, 'purchaseorder/' + codcompra, data)
      if (responseCallback) {
        responseCallback(email)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/api-compra.js